<template>
  <div>
    <b-modal
      v-model="modalShow"
      title="รายการสินค้า"
      hide-footer
      size="xl"
      no-close-on-backdrop
      no-close-on-esc
      header-class="bg-purple1"
    >
      <template #modal-header>
        <div class="w-100">
          <strong class="title-modal white-color">รายการสินค้า</strong>
          <b-icon
            icon="x-circle-fill"
            class="float-right pointer white-color"
            @click="modalShow = false"
          ></b-icon>
        </div>
      </template>
      <div class="filter-panel">
        <div class="category-panel">
          <b-row>
            <b-col>
              <InputSelect
                title="หมวดหมู่ระดับที่ 1"
                name="type"
                isRequired
                class="mt-2"
                v-model="filter.categories[0]"
                v-bind:options="categoryList.category1"
                valueField="value"
                textField="text"
                @onDataChange="onCateGoryChange($event, 1)"
              />
            </b-col>
            <b-col>
              <InputSelect
                title="หมวดหมู่ระดับที่ 2"
                name="type"
                isRequired
                class="mt-2"
                v-model="filter.categories[1]"
                v-bind:options="categoryList.category2"
                valueField="value"
                textField="text"
                @onDataChange="onCateGoryChange($event, 2)"
              />
            </b-col>
            <b-col>
              <InputSelect
                title="หมวดหมู่ระดับที่ 3"
                name="type"
                isRequired
                class="mt-2"
                v-model="filter.categories[2]"
                v-bind:options="categoryList.category3"
                valueField="value"
                textField="text"
                @onDataChange="onCateGoryChange($event, 3)"
              />
            </b-col>
            <b-col>
              <InputSelect
                title="หมวดหมู่ระดับที่ 4"
                name="type"
                isRequired
                class="mt-2"
                v-model="filter.categories[3]"
                v-bind:options="categoryList.category4"
                valueField="value"
                textField="text"
                @onDataChange="onCateGoryChange($event, 4)"
              />
            </b-col>
          </b-row>
        </div>
        <div class="search-panel">
          <div class="d-flex">
            <div class="w-100">
              <b-form-input
                class="ml-1 mt-2 search-input"
                v-model="filter.search"
                @keyup.enter="onSubmitFilter()"
                @blur="onSubmitFilter()"
                placeholder="ค้นหาด้วยชื่อสินค้า, SKU"
              ></b-form-input>
            </div>
            <div class="ml-1 my-auto">
              <b-button class="btn-search" @click="onSubmitFilter()">
                <font-awesome-icon icon="search" />
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <b-row class="mt-2">
        <b-col sm="12">
          <b-table
            responsive
            striped
            sticky-header
            :thStyle="tableHeaderStyle"
            class="mt-2 text-center table-list"
            :fields="fieldsSelectProduct"
            :items="productList"
            :busy="isBusy"
            show-empty
            empty-text="ไม่พบข้อมูล"
          >
            <template v-slot:head(id)="">
              <b-form-group class="cb-table">
                <b-form-checkbox
                  v-model="selectAllProduct"
                  @change="selectAllTable"
                ></b-form-checkbox>
              </b-form-group>
            </template>
            <template v-slot:cell(id)="data">
              <b-form-group class="cb-table">
                <b-form-checkbox
                  :value="data.item.id"
                  v-model="filter.productIdList"
                  @change="selectProductTable($event, data.item)"
                ></b-form-checkbox>
              </b-form-group>
            </template>
            <template v-slot:cell(imageUrl)="data">
              <div>
                <div
                  v-if="data.item.imageUrl"
                  class="table-image"
                  v-bind:style="{
                    'background-image': 'url(' + data.item.imageUrl + ')',
                  }"
                ></div>
                <div v-else>-</div>
              </div>
            </template>
            <template v-slot:cell(name)="data">
              <div class="text-left">
                <p class="m-0" v-if="data.item.name">
                  {{ data.item.name }}
                </p>
                <p class="m-0 text-gray" v-if="data.item.name">
                  {{ data.item.sku }}
                </p>
                <p v-else class="m-0">-</p>
              </div>
            </template>
            <template v-slot:cell(barcode)="data">
              <p class="m-0" v-if="data.item.barcode">
                {{ data.item.barcode }}
              </p>
              <p v-else class="m-0">-</p>
            </template>

            <template v-slot:cell(price)="data">
              <p class="m-0 price-text" v-if="data.item.price">
                ฿ {{ data.item.price | numeral("0,0.00") }}
              </p>
              <p v-else class="m-0 price-text">-</p>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
        <b-col sm="4"
          >ผลลัพธ์
          {{ filter.perPage > rows ? rows : filter.perPage }}
          รายการ จากทั้งหมด {{ rows }} รายการ</b-col
        >
        <b-col sm="8">
          <b-row class="px-3 pb-3">
            <b-col class="form-inline justify-content-end">
              <div class="d-sm-flex mr-3">
                <b-pagination
                  v-model="filter.pageNo"
                  :total-rows="rows"
                  :per-page="filter.perPage"
                  class="m-md-0 page-item"
                  @change="pagination"
                ></b-pagination>
              </div>
              <b-form-select
                v-model="filter.perPage"
                @change="hanndleChangePerpage"
                :options="pageOptions"
              ></b-form-select>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="6">
          <b-button class="btn-cancel-modal" size="lg" @click="hide"
            >ยกเลิก</b-button
          >
        </b-col>
        <b-col sm="6" class="text-right">
          <b-button class="btn-purple" size="lg" @click="submitProduct"
            >ตกลง</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";
export default {
  components: {
    InputSelect,
  },
  props: {
    promotionProductIdList: {
      type: Array,
      isRequired: true,
    },
    promotionProductNameList: {
      type: Array,
      isRequired: true,
    },
    productIdAll: {
      type: Array,
      isRequired: true,
    },
    productNameAll: {
      type: Array,
      isRequired: true,
    },
  },
  data() {
    return {
      modalShow: false,
      isBusy: false,
      fieldsSelectProduct: [
        {
          key: "id",
          label: "",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "8%",
          },
        },
        {
          key: "imageUrl",
          label: "รูปภาพ",
          class: "text-nowrap",
          thStyle: {
            width: "10vw !important",
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "20%",
          },
        },
        {
          key: "name",
          label: "ชื่อสินค้า (SKU)",
          class: "text-nowrap",
          thStyle: {
            width: "20vw !important",
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "35%",
          },
        },
        {
          key: "barcode",
          label: "บาร์โค้ด",
          class: "text-nowrap",
          thStyle: {
            width: "8vw !important",
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "20%",
          },
        },
        {
          key: "price",
          label: "ราคา",
          class: "text-nowrap",
          thStyle: {
            width: "8vw !important",
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "17%",
          },
        },
      ],
      productList: [],
      allListId: [],
      pageOptions: [
        { value: 5, text: "5 / หน้า" },
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      rows: 0,
      filter: {
        type: 1,
        search: "",
        pageNo: 1,
        perPage: 5,
        categories: [0, 0, 0, 0],
        isProductInCategory: false,
        productIdList: [],
        productNameList: [],
      },
      categoryList: {
        category1: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
        category2: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
        category3: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
        category4: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
      },
      tableHeaderStyle: {
        "background-color": "#d1d0e6 !important",
      },
      selectAllProduct: false,
    };
  },
  methods: {
    show() {
      this.getProductList();
      this.getCategoryList(0, 1);
      this.filter.productIdList = this.promotionProductIdList;
      this.filter.productNameList = this.promotionProductNameList;
      this.modalShow = true;
    },
    hide() {
      this.filter = {
        type: 1,
        search: "",
        pageNo: 1,
        perPage: 5,
        categories: [0, 0, 0, 0],
        isProductInCategory: false,
        productIdList: [],
        productNameList: [],
      };
      this.categoryList = {
        category1: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
        category2: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
        category3: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
        category4: [
          {
            value: 0,
            text: "ทั้งหมด",
          },
        ],
      };
      this.selectAllProduct = false;
      this.modalShow = false;
    },
    onSubmitFilter() {
      this.filter.pageNo = 1;
      this.filter.perPage = 5;
      this.getProductList();
    },
    submitProduct() {
      this.$emit("submitProduct", {
        idList: this.filter.productIdList,
        nameList: this.filter.productNameList,
      });
      this.hide();
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getProductList();
    },
    hanndleChangePerpage(value) {
      this.filter.pageNo = 1;
      this.filter.perPage = value;
      this.getProductList();
    },
    getProductList() {
      this.isBusy = true;
      this.axios
        .post(`${this.$baseUrl}/category/getProductList`, this.filter)
        .then((data) => {
          if (data.result == 1) {
            this.productList = data.detail.dataList;
            this.rows = data.detail.count;
            this.isBusy = false;
            this.allListId = data.detail.allListId;
          }
        });
    },
    clearCategory(id, index) {
      this.filter.categories.forEach((element, cindex) => {
        if (cindex > index) {
          this.categoryList[`category${cindex}`] = [
            {
              value: 0,
              text: "ทั้งหมด",
            },
          ];
          this.filter.categories[cindex] = 0;
        } else if (cindex == index) {
          this.filter.categories[cindex] = 0;
        }
      });
    },
    onCateGoryChange(id, index) {
      this.clearCategory(id, index);
      this.getCategoryList(id, index + 1);
      this.filter.categories[index - 1] = id;
      this.getProductList();
    },
    getCategoryList(id, index) {
      this.axios
        .get(`${this.$baseUrl}/productinventory/category/${id}`)
        .then((data) => {
          if (data.detail) {
            data.detail.category.forEach((l) => {
              this.categoryList[`category${index}`].push({
                value: l.categoryId,
                text: l.categoryName,
              });
            });
          } else {
            this.categoryList[`category${index}`] = [];
            this.categoryList[`category${index}`].push({
              value: 0,
              text: "ทั้งหมด",
            });
            this.filter.categories[index] = 0;
          }
        });
    },
    selectAllTable(value) {
      if (value) {
        this.filter.productIdList = [];
        this.filter.productNameList = [];
        this.filter.productIdList = this.allListId;
      } else {
        this.filter.productIdList = [];
      }
    },
    selectProductTable(value, data) {
      if (value) {
        this.filter.productNameList.push(data.name);
      } else {
        const equation = (element) => element == data.id;
        const index = this.filter.productIdList.findIndex(equation);
        this.filter.productNameList.splice(index, 1);
        this.selectAllProduct = false;
      }
    },
  },
};
</script>

<style scoped>
.input-search {
  color: #404040 !important;
  border: 1px solid #bcbcbc !important;
  border-radius: 6px !important;
  padding: 9px 10px !important;
  height: 41px;
}
.btn-collapse {
  color: #333333;
}
.white-color {
  color: #ffffff;
}
.text-gray {
  color: #bcbcbc;
}
.btn-purple {
  color: #ffffff;
  background-color: #7160c4;
}
.btn-cancel-modal {
  color: #7160c4;
  background-color: #ffffff;
  border: 1px solid #7160c4;
}
::v-deep .btn-select {
  height: 42.4px;
  color: #404040;
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  padding: 9px 10px;
  cursor: pointer;
}
::v-deep .btn-select.custom-select-lg {
  height: 55px;
  font-size: 1rem;
}
::v-deep .btn-select:focus {
  border-color: #80c141;
}
::v-deep .btn-select > option {
  background-color: white;
  color: #16274a;
}
::v-deep .btn-select > option:checked {
  color: #16274a !important;
}
::v-deep .btn-select:focus {
  box-shadow: unset !important;
}
.btn-select-product {
  width: 150px;
}
.btn-search {
  background-color: #8f20c6;
  color: #ffffff;
  width: 42.4px;
  height: 42.4px;
  padding: 6px 0px;
  margin-top: 10px !important;
  border-radius: 50px;
  text-align: center;
  font-size: 20px;
  line-height: 1.42857;
}
.search-input {
  height: 42.4px;
  width: 98%;
  border: 1px solid #b5b5b5;
  border-radius: 7px;
}
.btn-table-select {
  height: 42.4px;
}
.cb-table {
  position: relative;
  margin-left: 15px;
  padding-top: 15px;
}
</style>
